import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-wizard-form-select',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './wizard-form-select.component.html',
  styleUrl: './wizard-form-select.component.css',
  animations: [
    trigger('opacityAnimation', [
      transition(':enter', [
        style({ opacity: 0.3 }),
        animate('600ms ease-in-out', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class WizardFormSelectComponent {
  @Input() selectSettings!: {
    questionTitle: string;
    inputName: string;
    selectedOption: string;
    questionOptions: { id: number; title: string; value: string }[];
    handleOptionChange: (option: string, formPageName: string) => void;
    formPageName: string;   
  };

  userHasSelected: boolean = false;

  selectOption(event: any) {
    const selectedValue = event.target.value;
    this.selectSettings.handleOptionChange(selectedValue, this.selectSettings.formPageName);
  }
}